import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReframe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconReframe"><Path d="M17.8662 3.83984L16.8662 5.57129L13 3.33887V11.4219L20 15.4629V11H22V17.7734L16.1338 21.1602L15.1338 19.4277L18.999 17.1953L12 13.1543L5 17.1953L8.86621 19.4277L7.86621 21.1602L2 17.7734V11H4V15.4629L11 11.4219V3.33887L7.13379 5.57129L6.13379 3.83984L12 0.453125L17.8662 3.83984Z" fill="currentColor"/></CentralIconBase>;
});

export default IconReframe;
